/**
 * Mutable bridge between the DOM and the WebGL scenes. Written by React
 * components on interaction, read by the render loops every frame. Kept outside
 * React state on purpose: nothing here should ever trigger a re-render.
 */
export type ServiceKey = 'webapps' | 'eshops' | 'games';

export const sceneState = {
  /** Set once the loader has lifted, starts the intro choreography. */
  revealed: false,
  /** Pointer in normalized device coords (-1..1). */
  pointer: { x: 0, y: 0 },
  /** Service row currently hovered / centered, morphs the blob. */
  service: null as ServiceKey | null,
};

if (typeof window !== 'undefined') {
  window.addEventListener(
    'pointermove',
    (e) => {
      sceneState.pointer.x = (e.clientX / window.innerWidth) * 2 - 1;
      sceneState.pointer.y = -(e.clientY / window.innerHeight) * 2 + 1;
    },
    { passive: true }
  );
}

export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Lerp helper with frame-rate independent damping. */
export const damp = (
  current: number,
  target: number,
  lambda: number,
  dt: number
) => current + (target - current) * (1 - Math.exp(-lambda * dt));
